import type { CommonStrings } from "../../types";

export const common: CommonStrings = {
  nav: {
    blog: "Blog",
    github: "GitHub",
    productHunt: "Product Hunt",
  },
  footer: {
    blog: "Blog",
    privacy: "Privacy",
    impressum: "Impressum",
    github: "GitHub",
  },
  aria: {
    themeToLight: "Switch to light mode",
    themeToDark: "Switch to dark mode",
    prevTheme: "Previous theme",
    nextTheme: "Next theme",
    language: "Change language",
  },
};
